module.exports = __webpack_public_path__ + "img/card-reader.0cfe9655.svg";